import { BehaviorSubject } from 'rxjs';
// Angular modules
import { Injectable } from '@angular/core';
// External modules
import { TranslateService } from '@ngx-translate/core';
// Internal modules
import { environment } from '@env/environment';

/**
 * Angular Application State Management: You Do (Not) Need External Data Stores like NgRx, Redux, and Other
 * https://www.maestralsolutions.com/angular-application-state-management-you-do-not-need-external-data-stores/
 */
@Injectable()
export class StoreService {
  // NOTE Data
  private readonly _pageTitleSource = new BehaviorSubject<string>(
    environment.appName,
  );
  private readonly _isLoadingSource = new BehaviorSubject<boolean>(false);

  private activeRequests = 0;

  // NOTE Events
  readonly pageTitle$ = this._pageTitleSource.asObservable();
  readonly isLoading$ = this._isLoadingSource.asObservable();

  constructor(private translateService: TranslateService) {}

  // -------------------------------------------------------------------------------
  // NOTE Page title ---------------------------------------------------------------
  // -------------------------------------------------------------------------------

  public getPageTitle(): string {
    return this._pageTitleSource.getValue();
  }

  public setPageTitle(title: string, translate: boolean = true): void {
    const pageTitle = translate ? this.translateService.instant(title) : title;
    this._pageTitleSource.next(pageTitle);
  }

  public requestStarted(): void {
    this.activeRequests++;
    this._updateLoadingState();
  }

  public requestEnded(): void {
    this.activeRequests--;
    if (this.activeRequests < 0) {
      this.activeRequests = 0; // Ensure that the counter never goes negative
    }
    this._updateLoadingState();
  }

  private _updateLoadingState(): void {
    const isLoading = this.activeRequests > 0;
    this._isLoadingSource.next(isLoading);
  }

  showBanner(params: any) {
    // Implement banner display logic if needed
  }

  logError(message: any) {
    console.error(message);
  }
}
